module.exports = __webpack_public_path__ + "lb.svg?8da368bc7007a954d563479ae51cc1e9";